import { c as _c } from "react/compiler-runtime";
import { Field, FileUpload } from '@ark-ui/react';
import { IconButton } from '@chakra-ui/react';
import { FaFileImport } from 'react-icons/fa';
type ImportNetworkButtonProps = {
  importNetwork: (json: unknown) => void;
};
const ImportNetworkButton = t0 => {
  const $ = _c(6);
  const {
    importNetwork
  } = t0;
  let t1;
  if ($[0] !== importNetwork) {
    t1 = async e => {
      importNetwork(await e.files[0].text());
    };
    $[0] = importNetwork;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FileUpload.Trigger><IconButton aria-label="Import network" as="div" marginTop="1px" padding={3} size="md" title="Import network from JSON file" variant="outline"><FaFileImport /></IconButton></FileUpload.Trigger>;
    t3 = <FileUpload.HiddenInput data-testid="input" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <Field.Root><FileUpload.Root accept=".json" maxFiles={1} onFileAccept={t1}>{t2}{t3}</FileUpload.Root></Field.Root>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default ImportNetworkButton;